import React from 'react'
import { Link, graphql } from 'gatsby'

import Layout from '../components/layout'
// import HeroBanner from '../components/hero-banner'
import HeroBannerNew from '../components/hero-banner-new'
import ArticleCard from '../components/article-card'
import FeaturedIn from '../components/featured-in'
import HelmetBuilder from '../components/helmet-builder'

import { filterEntriesByField } from '../utils.js'

import Fade from 'react-reveal/Fade'

class Index extends React.Component {
  componentDidMount() {
    /* GTM pageview custom event trigger */
    window.dataLayer.push({
      virtualTitle: this.props.data.homepage.edges[0].node.metadata.title,
    })
    window.dataLayer.push({ event: 'virtualPageview' })
  }

  render() {
    // const allArticles = this.props.data.allArticles.edges

    const homepageComponents = filterEntriesByField(
      this.props.data.homepage.edges,
      'title',
      'fields-ref'
    )[0].node

    const featuredArticleBlock1 = homepageComponents.featuredArticleBlock1
      ? homepageComponents.featuredArticleBlock1
      : null

    const featuredArticleBlock2 = homepageComponents.featuredArticleBlock2
      ? homepageComponents.featuredArticleBlock2
      : null

    const featuredArticleBlock3 = homepageComponents.featuredArticleBlock3
      ? homepageComponents.featuredArticleBlock3
      : null

    // THIS IS CURRENTLY NOT IN USE BUT POTENTIALLY IN FUTURE
    // This method grabs all existing articles, filters them by 3 categories
    // and then removes duplicates with the Featured Article Blocks

    // const mainFeaturedArticle = homepageComponents.mainFeaturedArticle

    // Filtered Out Articles by Category

    // const filteredArticles = allArticles.filter(({ node }) => {
    //   // console.log('node ', node)
    //   return (
    //     node.slug !== mainFeaturedArticle.slug &&
    //     (featuredArticleBlock1 && node.slug !== featuredArticleBlock1.slug) &&
    //     (featuredArticleBlock2 && node.slug !== featuredArticleBlock2.slug) &&
    //     (featuredArticleBlock3 && node.slug !== featuredArticleBlock3.slug)
    //   )
    // })

    // const trendsStrategiesArticles = filteredArticles
    //   .filter(({ node }) => {
    //     if (node.category) {
    //       return node.category.slug === 'trends-and-strategies'
    //     }
    //   })
    //   .slice(0, 3)

    // const moneyMasterclassArticles = filteredArticles
    //   .filter(({ node }) => {
    //     if (node.category) {
    //       return node.category.slug === 'money-masterclass'
    //     }
    //   })
    //   .slice(0, 3)

    // const familyWealthArticles = filteredArticles
    //   .filter(({ node }) => {
    //     if (node.category) {
    //       return node.category.slug === 'family-and-wealth'
    //     }
    //   })
    //   .slice(0, 3)

    // End ---- Filtered Out Articles by Category

    const threeArticlesTrendsAndStrategies =
      homepageComponents.threeArticlesTrendsAndStrategies
    const threeArticlesMoneyMasterclass =
      homepageComponents.threeArticlesMoneyMasterclass
    const threeArticlesFamilyAndWealth =
      homepageComponents.threeArticlesFamilyAndWealth

    const metadata = homepageComponents.metadata

    // const artOfCollectingBanner =
    //   homepageComponents.featuredBannerArtOfCollecting

    const featured1LinkTitle = featuredArticleBlock1
      ? 'Navigate to: ' + featuredArticleBlock1.title
      : ''
    const featured2LinkTitle = featuredArticleBlock2
      ? 'Navigate to: ' + featuredArticleBlock2.title
      : ''
    const featured3LinkTitle = featuredArticleBlock3
      ? 'Navigate to: ' + featuredArticleBlock3.title
      : ''

    const featuredSeriesBlock1 = homepageComponents.featuredSeriesBlock1
    const featuredSeriesBlock2 = homepageComponents.featuredSeriesBlock2

    const mainFeaturedBanner = homepageComponents.mainFeaturedBanner[0]
    let title
    let slug
    let category
    let heroImage
    let heroImageTablet
    let heroImageMobile
    let typename
    if (mainFeaturedBanner.__typename === 'ContentfulPageArticle') {
      title = mainFeaturedBanner.title
      slug = mainFeaturedBanner.slug
      category = mainFeaturedBanner.category
        ? mainFeaturedBanner.category.title
        : null
      heroImage = mainFeaturedBanner.heroImage
      heroImageTablet = mainFeaturedBanner.heroImageTablet
        ? mainFeaturedBanner.heroImageTablet
        : mainFeaturedBanner.heroImage
      heroImageMobile = mainFeaturedBanner.heroImageMobile
        ? mainFeaturedBanner.heroImageMobile
        : mainFeaturedBanner.heroImage
      typename = mainFeaturedBanner.__typename
    } else if (mainFeaturedBanner.__typename === 'ContentfulPageWeeklyFive') {
      title = mainFeaturedBanner.headline
      slug = mainFeaturedBanner.slug
      category = mainFeaturedBanner.title
      heroImage = mainFeaturedBanner.heroImage
      heroImageTablet = mainFeaturedBanner.heroImageTablet
        ? mainFeaturedBanner.heroImageTablet
        : mainFeaturedBanner.heroImage
      heroImageMobile = mainFeaturedBanner.heroImageMobile
        ? mainFeaturedBanner.heroImageMobile
        : mainFeaturedBanner.heroImage
      typename = mainFeaturedBanner.__typename
    }

    return (
      <Layout pathname={this.props.location.pathname}>
        <div className="page page--landing">
          <HelmetBuilder
            title={`${metadata.title}`}
            description={metadata.description}
            image={metadata.openGraphImage.file.url}
            pathname={this.props.location.pathname}
          />

          <HeroBannerNew
            title={title}
            slug={slug}
            category={category}
            heroImage={heroImage}
            heroImageTablet={heroImageTablet}
            heroImageMobile={heroImageMobile}
            typename={typename}
            pathname={this.props.location.pathname}
          />

          <Fade>
            <div className="landing__articles-section block">
              <FeaturedIn
                category="Trends & Strategies"
                slug="trends-and-strategies"
                color="#8f6d25"
              />

              <div className="landing__articles-wrapper">
                {threeArticlesTrendsAndStrategies.map((article, i) => (
                  <ArticleCard article={article} color="#8f6d25" key={i} />
                ))}
              </div>

              <div className="landing__read-more">
                <Link
                  className="tracked"
                  to={'/categories/trends-and-strategies/'}
                >
                  Read More Articles
                </Link>
              </div>
            </div>
          </Fade>

          {featuredArticleBlock1 !== null && (
            <Fade>
              <Link
                title={featured1LinkTitle}
                to={`/articles/${featuredArticleBlock1.slug}/`}
                className="article-card__featured--full-bleed"
              >
                <div className="article__hero-image article__hero-image--lg">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredArticleBlock1.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--md">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredArticleBlock1.heroImageTablet
                          ? featuredArticleBlock1.heroImageTablet.file.url
                          : featuredArticleBlock1.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--sm">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredArticleBlock1.heroImageMobile
                          ? featuredArticleBlock1.heroImageMobile.file.url
                          : featuredArticleBlock1.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="gradient-middle" />
                <div className="block block__full-bleed">
                  <div className="featured--full-bleed__content-wrapper">
                    <div className="article-card__category">
                      {featuredArticleBlock1.category.title}
                    </div>
                    <div className="article-card__title">
                      {featuredArticleBlock1.title}
                    </div>

                    <div className="article-card__teaser">
                      {featuredArticleBlock1.shortDescription}
                    </div>

                    <div className="button button__transparent">
                      Read Article
                    </div>
                  </div>
                </div>
              </Link>
            </Fade>
          )}

          {featuredSeriesBlock1 !== null && (
            <Fade>
              <Link
                title={`Navigate to: ${featuredSeriesBlock1.title}`}
                to={`${featuredSeriesBlock1.slug}/`}
                className="article-card__featured--full-bleed featured-series-banner"
              >
                <div className="article__hero-image article__hero-image--lg">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredSeriesBlock1.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--md">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredSeriesBlock1.heroImageTablet
                          ? featuredSeriesBlock1.heroImageTablet.file.url
                          : featuredSeriesBlock1.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--sm">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredSeriesBlock1.heroImageMobile
                          ? featuredSeriesBlock1.heroImageMobile.file.url
                          : featuredSeriesBlock1.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                {/* <div className="gradient-middle" /> */}
                <div className="block block__full-bleed">
                  <div
                    className={`featured--full-bleed__content-wrapper ${
                      featuredSeriesBlock1.invertTextColor
                        ? `featured--full-bleed__content-wrapper--inverted`
                        : ''
                    }`}
                  >
                    <div className="article-card__category">
                      Featured Series
                    </div>
                    <div className="article-card__title">
                      {featuredSeriesBlock1.title}
                    </div>

                    <div className="article-card__teaser">
                      {featuredSeriesBlock1.shortDescription}
                    </div>

                    <div
                      className={`button ${
                        featuredSeriesBlock1.invertTextColor
                          ? `button__transparent`
                          : `button__blue-transparent`
                      }`}
                    >
                      Explore Articles
                    </div>
                    {featuredSeriesBlock1.heroImageCredit && (
                      <p className="article-card__credit">
                        {featuredSeriesBlock1.heroImageCredit}
                      </p>
                    )}
                  </div>
                </div>
              </Link>
            </Fade>
          )}

          {/* NOT IN USE - keep as it could maybe be reintroduced in future  
        {featuredSeries !== null &&
          featuredSeries.map(feature => (
            <Fade>
              <Link
                title={`Navigate to: ${feature.title}`}
                to={`${feature.slug}/`}
                className="article-card__featured--full-bleed featured-series-banner"
              >
                <div className="article__hero-image article__hero-image--lg">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        feature.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--md">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        feature.heroImageTablet
                          ? feature.heroImageTablet.file.url
                          : feature.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--sm">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        feature.heroImageMobile
                          ? feature.heroImageMobile.file.url
                          : feature.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="block block__full-bleed">
                  <div
                    className={`featured--full-bleed__content-wrapper ${
                      feature.invertTextColor
                        ? `featured--full-bleed__content-wrapper--inverted`
                        : ''
                    }`}
                  >
                    <div className="article-card__category">
                      Featured Series
                    </div>
                    <div className="article-card__title">{feature.title}</div>

                    <div className="article-card__teaser">
                      {feature.shortDescription}
                    </div>

                    <div
                      className={`button ${
                        feature.invertTextColor
                          ? `button__transparent`
                          : `button__blue-transparent`
                      }`}
                    >
                      Explore Articles
                    </div>
                  </div>
                </div>
              </Link>
            </Fade>
          ))}
*/}

          <Fade>
            <div className="landing__articles-section block">
              <FeaturedIn
                category="Money Masterclass"
                slug="money-masterclass"
                color="#787408"
              />

              <div className="landing__articles-wrapper">
                {threeArticlesMoneyMasterclass.map((article, i) => (
                  <ArticleCard article={article} color="#38813d" key={i} />
                ))}
              </div>

              <div className="landing__read-more">
                <Link className="tracked" to={'/categories/money-masterclass/'}>
                  Read More Articles
                </Link>
              </div>
            </div>
          </Fade>

          {featuredArticleBlock2 !== null && (
            <Fade>
              <Link
                title={featured2LinkTitle}
                to={`/articles/${featuredArticleBlock2.slug}/`}
                className="article-card__featured--full-bleed"
              >
                <div className="article__hero-image article__hero-image--lg">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredArticleBlock2.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--md">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredArticleBlock2.heroImageTablet
                          ? featuredArticleBlock2.heroImageTablet.file.url
                          : featuredArticleBlock2.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--sm">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredArticleBlock2.heroImageMobile
                          ? featuredArticleBlock2.heroImageMobile.file.url
                          : featuredArticleBlock2.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="gradient-middle" />
                <div className="block block__full-bleed">
                  <div className="featured--full-bleed__content-wrapper">
                    <div className="article-card__category">
                      {featuredArticleBlock2.category.title}
                    </div>
                    <div className="article-card__title">
                      {featuredArticleBlock2.title}
                    </div>

                    <div className="article-card__teaser">
                      {featuredArticleBlock2.shortDescription}
                    </div>

                    <div className="button button__transparent">
                      Read Article
                    </div>
                  </div>
                </div>
              </Link>
            </Fade>
          )}

          {featuredSeriesBlock2 !== null && (
            <Fade>
              <Link
                title={`Navigate to: ${featuredSeriesBlock2.title}`}
                to={`${featuredSeriesBlock2.slug}/`}
                className="article-card__featured--full-bleed featured-series-banner"
              >
                <div className="article__hero-image article__hero-image--lg">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredSeriesBlock2.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--md">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredSeriesBlock2.heroImageTablet
                          ? featuredSeriesBlock2.heroImageTablet.file.url
                          : featuredSeriesBlock2.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--sm">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredSeriesBlock2.heroImageMobile
                          ? featuredSeriesBlock2.heroImageMobile.file.url
                          : featuredSeriesBlock2.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                {/* <div className="gradient-middle" /> */}
                <div className="block block__full-bleed">
                  <div
                    className={`featured--full-bleed__content-wrapper ${
                      featuredSeriesBlock2.invertTextColor
                        ? `featured--full-bleed__content-wrapper--inverted`
                        : ''
                    }`}
                  >
                    <div className="article-card__category">
                      Featured Series
                    </div>
                    <div className="article-card__title">
                      {featuredSeriesBlock2.title}
                    </div>

                    <div className="article-card__teaser">
                      {featuredSeriesBlock2.shortDescription}
                    </div>

                    <div
                      className={`button ${
                        featuredSeriesBlock2.invertTextColor
                          ? `button__transparent`
                          : `button__blue-transparent`
                      }`}
                    >
                      Explore Articles
                    </div>
                    {featuredSeriesBlock2.heroImageCredit && (
                      <p className="article-card__credit">
                        {featuredSeriesBlock2.heroImageCredit}
                      </p>
                    )}
                  </div>
                </div>
              </Link>
            </Fade>
          )}

          <Fade>
            <div className="landing__articles-section block">
              <FeaturedIn
                category="Family & Wealth"
                slug="family-and-wealth"
                color="#38813d"
              />

              <div className="landing__articles-wrapper">
                {threeArticlesFamilyAndWealth.map((article, i) => (
                  <ArticleCard article={article} color="#38813d" key={i} />
                ))}
              </div>

              <div className="landing__read-more">
                <Link className="tracked" to={'/categories/family-and-wealth/'}>
                  Read More Articles
                </Link>
              </div>
            </div>
          </Fade>

          {/* Featured Block 3 - Old Version
        {featuredArticleBlock3 !== null && (
          <Fade>
            <div className="article-card__featured--full-bleed-variant">
              <Link
                title={featured3LinkTitle}
                className="block block__full-bleed"
                to={`/articles/${featuredArticleBlock3.slug}/`}
              >
                <div className="block__full-bleed-content">
                  <div
                    className="article-card__category section-header-line--left"
                    style={{ color: '#38813d' }}
                  >
                    {featuredArticleBlock3.category.title}
                  </div>
                  <div className="article-card__title">
                    {featuredArticleBlock3.title}
                  </div>

                  <div className="article-card__teaser">
                    {featuredArticleBlock3.shortDescription}
                  </div>
                </div>
                <div className="block__full-bleed-media">
                  <img
                    src={featuredArticleBlock3.heroImage.file.url}
                    alt={`Image - ${featuredArticleBlock3.title}`}
                  />
                </div>
              </Link>
            </div>
          </Fade>
        )}
*/}

          {featuredArticleBlock3 !== null && (
            <Fade>
              <Link
                title={featured3LinkTitle}
                to={`/articles/${featuredArticleBlock3.slug}/`}
                className="article-card__featured--full-bleed"
              >
                <div className="article__hero-image article__hero-image--lg">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredArticleBlock3.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--md">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredArticleBlock3.heroImageTablet
                          ? featuredArticleBlock3.heroImageTablet.file.url
                          : featuredArticleBlock3.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="article__hero-image article__hero-image--sm">
                  <div
                    className="article__hero-image-background"
                    style={{
                      backgroundImage: `url("${
                        featuredArticleBlock3.heroImageMobile
                          ? featuredArticleBlock3.heroImageMobile.file.url
                          : featuredArticleBlock3.heroImage.file.url
                      }?fm=jpg&q=90")`,
                    }}
                  />
                </div>
                <div className="gradient-middle" />
                <div className="block block__full-bleed">
                  <div className="featured--full-bleed__content-wrapper">
                    <div className="article-card__category">
                      {featuredArticleBlock3.category.title}
                    </div>
                    <div className="article-card__title">
                      {featuredArticleBlock3.title}
                    </div>

                    <div className="article-card__teaser">
                      {featuredArticleBlock3.shortDescription}
                    </div>

                    <div className="button button__transparent">
                      Read Article
                    </div>
                  </div>
                </div>
              </Link>
            </Fade>
          )}
        </div>
      </Layout>
    )
  }
}

export default Index

export const pageQuery = graphql`
  query IndexPageQuery {
    homepage: allContentfulPageHomepage {
      edges {
        node {
          id
          title
          metadata {
            title
            description
            openGraphImage {
              file {
                url
              }
            }
          }
          mainFeaturedArticle {
            title
            slug
            shortDescription
            category {
              title
              slug
            }
            featuredPage {
              title
              slug
            }
            heroImage {
              file {
                url
              }
            }
            heroImageTablet {
              file {
                url
              }
            }
            heroImageMobile {
              file {
                url
              }
            }
          }
          mainFeaturedBanner {
            ... on Node {
              ... on ContentfulPageArticle {
                __typename
                title
                slug
                shortDescription
                category {
                  title
                  slug
                }
                featuredPage {
                  title
                  slug
                }
                heroImage {
                  file {
                    url
                  }
                }
                heroImageTablet {
                  file {
                    url
                  }
                }
                heroImageMobile {
                  file {
                    url
                  }
                }
              }
            }
            ... on Node {
              ... on ContentfulPageWeeklyFive {
                __typename
                title
                headline
                slug
                heroImage {
                  file {
                    url
                  }
                }
                heroImageTablet {
                  file {
                    url
                  }
                }
                heroImageMobile {
                  file {
                    url
                  }
                }
              }
            }
          }
          threeArticlesTrendsAndStrategies {
            title
            slug
            shortDescription
            category {
              title
              slug
            }
            heroImage {
              file {
                url
              }
            }
            heroImageThumbnail {
              file {
                url
              }
            }
          }
          threeArticlesMoneyMasterclass {
            title
            slug
            shortDescription
            category {
              title
              slug
            }
            heroImage {
              file {
                url
              }
            }
            heroImageThumbnail {
              file {
                url
              }
            }
          }
          threeArticlesFamilyAndWealth {
            title
            slug
            shortDescription
            category {
              title
              slug
            }
            heroImage {
              file {
                url
              }
            }
            heroImageThumbnail {
              file {
                url
              }
            }
          }

          featuredArticleBlock1 {
            title
            slug
            shortDescription
            category {
              title
              slug
            }
            featuredPage {
              title
              slug
            }
            heroImage {
              file {
                url
              }
            }
            heroImageTablet {
              file {
                url
              }
            }
            heroImageMobile {
              file {
                url
              }
            }
          }
          featuredSeriesBlock1 {
            title
            slug
            shortDescription
            heroImage {
              file {
                url
              }
            }
            heroImageTablet {
              file {
                url
              }
            }
            heroImageMobile {
              file {
                url
              }
            }
            invertTextColor
            heroImageCredit
          }
          featuredArticleBlock2 {
            title
            slug
            shortDescription
            category {
              title
              slug
            }
            featuredPage {
              title
              slug
            }
            heroImage {
              file {
                url
              }
            }
            heroImageTablet {
              file {
                url
              }
            }
            heroImageMobile {
              file {
                url
              }
            }
          }
          featuredSeriesBlock2 {
            title
            slug
            shortDescription
            heroImage {
              file {
                url
              }
            }
            heroImageTablet {
              file {
                url
              }
            }
            heroImageMobile {
              file {
                url
              }
            }
            invertTextColor
            heroImageCredit
          }
          featuredArticleBlock3 {
            title
            slug
            shortDescription
            category {
              title
              slug
            }
            featuredPage {
              title
              slug
            }
            heroImage {
              file {
                url
              }
            }
            heroImageTablet {
              file {
                url
              }
            }
            heroImageMobile {
              file {
                url
              }
            }
          }
          featuredBannerArtOfCollecting {
            title
            slug
            shortDescription
            heroImage {
              file {
                url
              }
            }
            heroImageTablet {
              file {
                url
              }
            }
            heroImageMobile {
              file {
                url
              }
            }
          }
          featuredSeries {
            title
            slug
            shortDescription
            heroImage {
              file {
                url
              }
            }
            heroImageTablet {
              file {
                url
              }
            }
            heroImageMobile {
              file {
                url
              }
            }
            invertTextColor
          }
        }
      }
    }

    allArticles: allContentfulPageArticle(
      sort: { fields: [date], order: DESC }
    ) {
      edges {
        node {
          id
          title
          date
          slug
          shortDescription
          category {
            title
            slug
          }
          heroImage {
            file {
              url
            }
          }
        }
      }
    }

    categories: allContentfulCategory {
      edges {
        node {
          title
          slug
          shortDescription
          page___article {
            id
            title
            slug
            shortDescription
            category {
              title
            }
            heroImage {
              file {
                url
              }
            }
          }
        }
      }
    }
  }
`
